import { render, staticRenderFns } from "./FItems.vue?vue&type=template&id=3d00a18a&"
import script from "./FItems.vue?vue&type=script&lang=js&"
export * from "./FItems.vue?vue&type=script&lang=js&"
import style0 from "./FItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports